import { NgModule, NO_ERRORS_SCHEMA  } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrimengModule } from '@app/shared/modules/primeng.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MailTemplateModule } from '@app/shared';
import { DirectivesModule } from '@app/@core/directives/directives.module';
import { CardiDocumentManagementModule } from '@pics-module/document-management';
import { DocumentUploadComponent } from './document-upload.component';
import { NgxfUploaderModule } from 'ngxf-uploader';

@NgModule({
  declarations: [DocumentUploadComponent],
  imports: [
    CommonModule,
    PrimengModule,
    FormsModule,
    MailTemplateModule,
    DirectivesModule,
    CardiDocumentManagementModule,
    ReactiveFormsModule,
    NgxfUploaderModule
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class DocumentUploadModule {}
